export default __webpack_public_path__ + "static/sysdig-e85ed5aeb88ad80b9b3f20494e43ddaf.svg";